import { render } from "./ObjectAddTemplate.vue?vue&type=template&id=3350a074"
import script from "./ObjectAddTemplate.vue?vue&type=script&lang=js"
export * from "./ObjectAddTemplate.vue?vue&type=script&lang=js"

import "./ObjectAddTemplate.vue?vue&type=style&index=0&id=3350a074&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__